import { defineComponent as _defineComponent } from 'vue'
interface Props {
  size?: string;
  type?: string;
  link?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    size: { default: 'medium' },
    type: { default: 'primary' },
    link: { default: '' }
  },
  setup(__props: any) {

/**
 * Button UI component
 *
 * @parent:
 * @requests:
 * @events: click - Click action on the button
 * @props: label - Label of the button
 * @props: type - Valid values are primary, secondary, link, tertiary, outlines
 * @props: link - If this is set, indicates it should be a link.
 * @methods:
 */



return { __sfc: true, }
}

})